
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, NgForm } from '@angular/forms';
import { SuicidalityService } from './suicidality.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import {B2CAdminComponent} from "../../b2c-admin.component";
import {MaintenanceComponent} from "../../../../maintenance/maintenance.component";
import {SuicidalityModel} from "./suicidality.model";

@Component({
    selector: 'suicidality-component',
    templateUrl: './suicidality.component.html',
    styleUrls: ['./suicidality.component.scss'],
    providers: [SuicidalityService]
})

export class SuicidalityComponent extends B2CAdminComponent implements OnInit, AfterViewInit {
    @Input() isHome = false;
    @Input() filters;
    items: Object[] = [];
    userRoleId: number;
    data: any;
    collapse = true;
    sortUsingApi = false;
    // define what table columns
    // to display [column key, label, css class]
    readonly tableColumns = [
        ['patient_id', 'Patient Id', 'col-xs-1'],
        ['official_name', 'Patient name', 'col-xs-2'],
        ['therapist_id', 'Therapist id', 'col-xs-1'],
        ['therapist_name', 'Therapist name', 'col-xs-2'],
        ['type_text', 'Status', 'col-xs-2'],
        ['suicidal', 'Suicidal', 'col-xs-1'],
        ['credibly_distant', 'Credibly distant', 'col-xs-2'],
        ['created_at_format', 'Created At', 'col-xs-1']
    ];

    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintain: MaintenanceComponent,
                public service: SuicidalityService)  {
        super(authService, coreService, router, translate, fb, baseService, appService, usersService, homeService, clinicService, maintenanceService, secureApi, maintain);
    }

    ngOnInit() {
        super.ngOnInit();
        this.searchInfo = new SuicidalityModel();
        this.token = this.authService.user['token'];

        // sort
        this.initSorting();

        this.itemsPerPage = 15;
        if (this.isHome) {
            this.itemsPerPage = 5;
        } else{
            return this.getItems();
        }
    }

    ngAfterViewInit() {
    }

    /**
     * preload mobile number for mobile field
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    getItems() {

        this.service.getAll(this.filters).subscribe(response => {
            this.isLoading = false;
            this.items = response['items'];
        });
    }

    sortData(column) {
        if (column === 'created_at_format') {
            column = 'created_at_sort';
        }

        this.sort(column, false, this.sortUsingApi);
    }
}
